import DescriptionText from 'elements/DescriptionText';
import ds from 'designsystem';
import { media } from 'designsystem/index';
import Paragraph from 'elements/Paragraph';

const Description = DescriptionText.extend`
  color: ${ds.brand('white')};
  margin-top: 0;
  
  & > ${Paragraph} {
    color: ${ds.brand('white')};
    font-size: ${ds.fontSize('base')};
    font-weight: ${ds.get('type.fontWeight.light')};
    opacity: 0.9;
    padding: 0;
    margin: 0;
  }
  
  margin-bottom: ${ds.get('metrics.m')};

  ${media.tablet`
    margin-top: ${ds.get('metrics.xl')};
    margin-bottom: calc(${ds.get('metrics.xxl')} - ${ds.get('metrics.s')});
  `}
  
  ${media.desktop`
    line-height: ${ds.get('type.lineHeight.xl')};
    margin-top: ${ds.get('metrics.xxl')};
    
    & > ${Paragraph} {
      font-size: ${ds.fontSize('m')};
    }
  `}
`;

export default Description;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ImageSlider/ImageSlide/Description.jsx